module.exports = __webpack_public_path__ + "static/media/football.8fe5b68d.jpg";